<template>

    <div>
        <button class="btn btn-box-tool" @click="openSearch()"><slot></slot></button>
        <crm-selector :on-selected="selectContact"></crm-selector>
    </div>

</template>

<script>

    import { mapActions } from 'vuex';
    import CrmSelector from '../Common/Selectors/CrmSelector';
    import Hub from '../../Hub';
    import axios from 'axios';

    export default {

        components: {
            CrmSelector,
        },

        methods: {

            ...mapActions([
                "parseData",
            ]),

            closeSearch() {
                Hub.$emit("close-contact-selector");
            },

            openSearch() {
                Hub.$emit("open-contact-selector");
            },

            selectContact(contact){
                axios.post(this.addUri, {
                    contact_uuid:contact.uuid,
                    is_contact:contact.isContact,
                }).then(() => {
                    this.$snotify.success("De contactpersoon in toegevoegd");
                    Hub.$emit("contact-added-to-project");
                });
                this.closeSearch();
            },

        },

        mounted() {
            this.parseData();
        },

        name:"ProjectsAddContactButton",

        props: {
            addUri: {required:true },
        }

    }

</script>
